import React from 'react'
import { Card } from './Card';

export const Cards = (props) => {
    const course= props.data;
    const allCourses=[];
    const category=props.categary;
    const getAllCouses=() =>{
        if(category==='All')
        {
            Object.values(course).forEach((courseCategory)=>{
                courseCategory.forEach((sepcourse) =>{
                    allCourses.push(sepcourse);
                })
            })
            return allCourses
        }
        else{
            return course[category];
        }
      
    }
  return (
    <div className='flex  w-full'>
        <div className='w-11/12 max-w-[1080px] flex flex-wrap gap-3 mx-auto justify-center'>
        {
            getAllCouses().map((card,index)=>{
                return <Card details={card} key={index} ></Card>;
            })
        }
            
        </div>
       

    </div>
  )
}
